(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initRoot(root) {
    // Enabling JS swaps the panel CSS to the animatable (0fr default) variant.
    root.classList.add('yb-faq--js');

    var cards = Array.prototype.slice.call(root.querySelectorAll('.yb-faq__card'));

    // Sync server-rendered open card to the class the JS path uses.
    // Done synchronously (before paint) so no open->collapse->open flash occurs.
    cards.forEach(function (card) {
      if (card.open) card.classList.add('is-open');
    });

    function closeCard(card, animate) {
      var panel = card.querySelector('.yb-faq__panel');
      if (!animate) {
        card.classList.remove('is-open');
        card.open = false;
        return;
      }
      card.classList.remove('is-open'); // animates grid-template-rows -> 0fr
      var done = function (e) {
        if (e && e.target !== panel) return;
        panel.removeEventListener('transitionend', done);
        // If it was re-opened mid-close, don't yank it shut.
        if (!card.classList.contains('is-open')) card.open = false;
      };
      panel.addEventListener('transitionend', done);
    }

    function openCard(card, animate) {
      card.open = true; // reveal content first so it can animate from 0fr
      if (!animate) {
        card.classList.add('is-open');
        return;
      }
      // Two frames: let a 0fr frame paint, then transition to 1fr.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          card.classList.add('is-open');
        });
      });
    }

    cards.forEach(function (card) {
      var summary = card.querySelector('.yb-faq__summary');
      if (!summary) return;

      summary.addEventListener('click', function (e) {
        e.preventDefault(); // we drive open/close ourselves
        var animate = !prefersReduced.matches;

        if (card.classList.contains('is-open')) {
          closeCard(card, animate);
        } else {
          // Single-open: collapse any sibling that's open.
          cards.forEach(function (other) {
            if (other !== card && other.classList.contains('is-open')) {
              closeCard(other, animate);
            }
          });
          openCard(card, animate);
        }
      });
    });
  }

  // Roll physics: distance = pill width - ball - margins; rotation matched to
  // distance (distance / ball circumference) so it reads as rolling, not spinning.
  function sizePillRoll(root) {
    var pill = root.querySelector('.yb-faq__pill');
    var ball = root.querySelector('.yb-faq__pill-ball');
    if (!pill || !ball) return;
    var travel = pill.clientWidth - ball.offsetWidth - 16;
    if (travel < 0) travel = 0;
    var circumference = Math.PI * ball.offsetWidth;
    var deg = circumference ? (travel / circumference) * 360 : 0;
    ball.style.setProperty('--yb-roll-x', travel + 'px');
    ball.style.setProperty('--yb-roll-deg', deg + 'deg');
  }

  var roots = document.querySelectorAll('.yb-faq');
  for (var i = 0; i < roots.length; i++) {
    initRoot(roots[i]);
    sizePillRoll(roots[i]);
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      for (var j = 0; j < roots.length; j++) sizePillRoll(roots[j]);
    }, 150);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
